import React from 'react';

import {
  BoxProps,
  Box,
} from '@waglabs/box-next';
import { FlexProps } from '@waglabs/flex-next';

/**
 * TODO:
 * Figure out why `FlexProps` don't have the `onClick`
 */
export type CardProps = Pick<BoxProps, 'onClick'> & FlexProps & {
  raised?: boolean;
};

// TODO - @waglabs/flex-next package should forwardRef
export const Card = React.forwardRef<any, CardProps>(({
  raised = false,
  ...others
}, ref) => (
  <Box
    display="flex"
    borderRadius="16px"
    border="1px solid #D1D1D1"
    boxShadow={raised ? '0 2px 12px 0 rgba(0,0,0,0.2)' : 'none'}
    ref={ref as any}
    {...others}
  />
));
